import { render, staticRenderFns } from "./IbTooltipConfirm.vue?vue&type=template&id=674b3f73&scoped=true"
import script from "./IbTooltipConfirm.vue?vue&type=script&lang=js"
export * from "./IbTooltipConfirm.vue?vue&type=script&lang=js"
import style0 from "./IbTooltipConfirm.vue?vue&type=style&index=0&id=674b3f73&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b3f73",
  null
  
)

export default component.exports